import LaunchIcon from '@mui/icons-material/Launch'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'

import { DisciplineIcons } from '@components/DisciplineIcons'
import { MyListButton } from '@components/MyListButton'
import { PlanningsverschilIcon } from '@components/PlanningsverschilIcon'
import { Status } from '@components/Status'
import { formatDate } from '@util/date-util'

import { Label } from '../../../theme/components/Label'
import { StyledIconLink } from '../../../theme/components/StyledIconLink'
import type { HoofdleidingProject } from '../../project/types/HoofdleidingProject'

import { Mijlpalen } from './Mijlpalen'

interface Props {
  project: HoofdleidingProject
  onClickMenu: (anchorEl: HTMLElement, project: HoofdleidingProject) => void
}

export const ProjectenTableRow = ({ project, onClickMenu }: Props) => {
  const {
    aanvraagID,
    adres,
    disciplineVerzamelingen,
    gebiedscodeLabel,
    startUitvoeringWeek,
    externeReferentie,
    naam,
    typeWerk,
    gemeente,
    statusText,
    labels,
    planningChanged,
  } = project

  const handleMenu = (event) => {
    onClickMenu(event.currentTarget, project)
  }

  return (
    <TableRow>
      <TableCell>
        <Box>
          <Status project={project} />
        </Box>
      </TableCell>
      <TableCell>
        {naam}
        <br />
        <Typography variant="caption">
          <span>#</span>
          {aanvraagID}
        </Typography>
      </TableCell>
      <TableCell>
        {externeReferentie}
        <br />
        {labels && labels.length > 0 && (
          <div>
            {labels.map((l) => (
              <Label text={l} key={l} small />
            ))}
          </div>
        )}
      </TableCell>
      <TableCell>
        {adres}
        <br />
        <Typography variant="caption">gem. {gemeente}</Typography>
      </TableCell>
      <TableCell>
        {typeWerk}
        <br />
        <Typography variant="caption">{gebiedscodeLabel}</Typography>
      </TableCell>
      <TableCell>
        <Box sx={{ display: 'flex' }}>
          <DisciplineIcons disciplineVerzamelingen={disciplineVerzamelingen} />
        </Box>
      </TableCell>
      <TableCell>
        {planningChanged ? formatDate(planningChanged) : ''}
      </TableCell>
      <TableCell>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box>{startUitvoeringWeek}</Box>
          {project.planningsverschillen?.map((pv) => (
            <PlanningsverschilIcon
              key={pv}
              context="project"
              planningsverschil={pv}
            />
          ))}
        </Box>
      </TableCell>
      <TableCell>{statusText}</TableCell>
      <TableCell>
        <Mijlpalen
          bijlagen={project.bijlagen}
          disciplineVerzamelingen={disciplineVerzamelingen}
          mijlpalen={project.mijlpalen?.items}
        />
      </TableCell>
      <TableCell>
        <MyListButton
          type="hoofdleiding"
          active={project.myList}
          aanvraagID={project.aanvraagID}
        />

        <StyledIconLink
          title={`Navigeer naar project ${aanvraagID}`}
          icon={<LaunchIcon />}
          href={`/hoofdleiding/project/${aanvraagID}`}
        />

        <IconButton data-testid="buttonMenu" onClick={handleMenu}>
          <MoreVertIcon />
        </IconButton>
      </TableCell>
    </TableRow>
  )
}
